import { HttpHeaders } from '@angular/common/http';
import { Component } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { jamarekObj } from 'src/app/models/jamarekObj';
import { environment } from 'src/environments/environment';
import { ApiService } from 'src/services/apiService';
import { AuthService } from 'src/services/auth.service';
import { SweetAlertService } from 'src/services/sweetAlertService';
import jwt_decode from "jwt-decode";
import { CustomValidators } from 'src/app/validator/custom-validators';

@Component({
  selector: 'app-edit-jamarek-transfer-quantity',
  templateUrl: './edit-jamarek-transfer-quantity.component.html',
  styleUrls: ['./edit-jamarek-transfer-quantity.component.css']
})
export class EditJamarekTransferQuantityComponent {

  form!: FormGroup;
  statisticalUnits:any[]=[];
  units:any[][] = [];
  taxUnits:any[][] = [];
  carbonCopyId:string|undefined;
  hideadditionalCode=false;
  formSubmited:boolean=false;
  isLoading=true;
  
  firstTime=true;
  showSaveBtn=true;  
  showLicenseError=false;

  editMode:boolean=false;

  public exemptAssetsList:any[]=[];
  idsZero:boolean=false;
  showSearchBtn=true;
  employeeId:string|undefined;
  showJamarek=true;
  showTax=true;
  formType:string="1";
  token:string="";
  mainPath = "" // قراءة القيمة من environment


  getExemptAssetsList(){

    var request=this.apiService.get("Moin/GetFindings",`${environment.govnet}`,undefined,this.token);;

    request.subscribe(response=>{
      var data=response.data.list as any[];

      var newList= data.map(item=>{

        var value=  item.value as string;

        var newValue=value.substring(0,50);

        return  {
          key:item.key,
          value:newValue,
        }

      });

      this.exemptAssetsList=newList;

    });
  }

  constructor(private fb: FormBuilder,private apiService:ApiService,private authService:AuthService,
    private route: ActivatedRoute,private alertService:SweetAlertService) {
      this.mainPath= environment.MainPath;

    this.token= this.route.snapshot.queryParamMap.get('Token')!;

    this.getExemptAssetsList();
    this.fillStaticUnit();

    if(this.route.snapshot.queryParams['Token'] && this.route.snapshot.queryParams['Carponcopyid']){

      this.carbonCopyId= this.route.snapshot.queryParamMap.get('Carponcopyid')!;

      this.formType= this.route.snapshot.queryParamMap.get('formType')!;

      if(this.formType=="2"){

        var showingType = this.route.snapshot.queryParamMap.get('show')!;

        if(showingType=="jamarek"){

          this.showJamarek=true;
          this.showTax=false;

        }else if(showingType=="tax"){

          this.showJamarek=false;
          this.showTax=true;

        }


      }

      this.fillApplicant(this.carbonCopyId,false);

      var TaxNumber = this.route.snapshot.queryParamMap.get('TaxNumber')!;

      this.form = this.fb.group({
        taxNumber:[TaxNumber, Validators.required],
        licenseId:['', Validators.required],
        formItems: this.fb.array([]),
        taxItems: this.fb.array([]),
      });

      var token = this.route.snapshot.queryParamMap.get('Token')!;

      var decoded = jwt_decode(token) as any;

      this.employeeId= decoded.sub;
      
      this.checkValidty();
      
      this.hideadditionalCode=false;

    }else{
      location.href="/"+this.mainPath+"/Dashboard";
    }

  }

  fillApplicant(carbonId:string,search:boolean){

    if(carbonId=="" || carbonId==null){
      this.showLicenseError=true;
      return;
    }else{
      this.showLicenseError=false;

    }

    this.isLoading=true;



    var request=this.apiService.get('Moin/GetJamarekTaxApplicantData?licenseId='+carbonId,`${environment.govnet}`,undefined,this.token);;

    request.subscribe(response=>{

  
      var jamarekImtems=response.data.jamarek as any[];

      var taxImtems=response.data.tax as any[];

      if(jamarekImtems.length==0 && taxImtems.length==0){
        this.editMode=false;

        if(!search){
          this.idsZero=true;
        }

      }else{
        this.editMode=true;
        if(!search){
          this.showSearchBtn=false;
        }

      }

      if(response.oldCarbonId!=null){
        this.form.get('licenseId')?.setValue(response.oldCarbonId);
      }

      if(jamarekImtems.length>0){

        this.form.get('taxNumber')?.setValue(jamarekImtems[0].taxNumber);

        jamarekImtems.map((item,index)=>{

          var obj=new jamarekObj(item.id,item.searchKeyword,item.hsCode,item.remainingQuantity,item.statisticalUnit,item.additionalCode,item.exemptAssets,true,item.totalPrice,item.description,item.credits,item.note);
          var form= this.generateItem(obj);
          this.searchEnquiry(item.searchKeyword,index);
          this.addItemWithValue(form);

          this.isLoading=false;

        })
      }else{
        this.isLoading=false;
      }

      if(taxImtems.length>0){

        this.form.get('taxNumber')?.setValue(taxImtems[0].taxNumber);

        taxImtems.map((item,index)=>{

          var obj=new jamarekObj(item.id,item.searchKeyword,item.hsCode,item.remainingQuantity,item.statisticalUnit,item.additionalCode,item.exemptAssets,true,item.totalPrice,'','','');
          var form= this.generateItem(obj);
          //this.searchTaxEnquiry(item.searchKeyword,index);
          this.addTaxItemWithValue(form);

          this.isLoading=false;

        })
      }else{

        this.isLoading=false;

      }

    });

  }

  checkValidty(){


    var request=this.apiService.get(`Moin/GetEditFormByConsumerStatus?carbonId=${this.carbonCopyId}`,`${environment.govnet}`,undefined,this.token);;

    request.subscribe(response=>{

      this.isLoading=false;

      if(response.data.value==true){
        
        this.showSaveBtn=false;
        
      }
    });

  }

  generateItem(data?: {
    id?: number;
    unitName?: string;
    unitId?: string;
    quantity?: string;
    exemptAssets?: string;
    staticUnit?: string;
    additionalCode?: number;
    hsCode?: boolean;
    fromDb:boolean;
    totalPrice: number;
    description: string;
    note: string;
    credits: string;
  }): FormGroup {

    return this.fb.group({
      id: [data?.id ||0],
      unitName: [data?.unitName || '', Validators.required],
      unitId: [data?.unitId || '', [Validators.required]],
      quantity: [data?.quantity || '0', Validators.required],
      exemptAssets: [ data?.exemptAssets  || '', this.formType!="2"? Validators.required:false],
      staticUnit: [data?.staticUnit || '', Validators.required],
      additionalCode: [data?.additionalCode || '' , Validators.required],
      hsCode: [data?.unitId || ''],
      fromDb: data?.fromDb??false,
      totalPrice: [data?.totalPrice || '0', Validators.required],
      description: [data?.description || '' ],
      note: [data?.note || ''],
      credits: [data?.credits || ''],
    });
    
  }

  get Items() {
    return this.form.get('formItems') as FormArray;
  }

  get TaxItems() {
    return this.form.get('taxItems') as FormArray;
  }

  addItem() {
    this.Items.push(this.generateItem());
  }

  addItemWithValue(data:FormGroup) {
    this.Items.push(data);
  }


  removeJamarek(index: number) {
    this.Items.removeAt(index);
  }

  removeTax(index: number) {
    this.TaxItems.removeAt(index);
  }

  addTaxItem() {
    this.TaxItems.push(this.generateItem({exemptAssets:"1",hsCode:false,staticUnit:"1",unitId:"1",fromDb:false,totalPrice:0,description:'-',credits:'-',note:'-'}));
  }


  addTaxItemWithValue(data:FormGroup) {
    this.TaxItems.push(data);
  }

  
  onSubmit() {

    this.formSubmited=true;

    var canSubmit=true;



    if(this.form.valid){

      this.formSubmited=false;
      this.showSaveBtn=false;

      var gamarekExemptionReqest:any[]=[];

      var taxExemptionReqest:any[]=[];

      let items = this.Items;
      let taxItems = this.TaxItems;

      items.controls.forEach((control, index) => {

        let searchText= $(`#unitId-${index} option:selected`).text();

        if(searchText=='يرجى الاختيار'){
          
          this.alertService.ShowAlert('warning','يرجى التأكد من اختيار جميع العناصر');

          this.isLoading=false;
          this.showSaveBtn=true;
          canSubmit= false;
        }
      });

      if(canSubmit){

        items.controls.forEach((control, index) => {

          var data={
            "id": this.idsZero==false ? control.get('id')?.value : 0,
            "ssCode": control.get('unitId')?.value,
            "quantity": control.get('quantity')?.value,
            "statisticalUnit": control.get('staticUnit')?.value,
            "exemptAssets": control.get('exemptAssets')?.value,
            "additionalCode":control.get('additionalCode')?.value ,
            "searchKeyword": control.get('unitName')?.value,
            "description":control.get('description')?.value ,
            "note":control.get('note')?.value ,
            "credits":control.get('credits')?.value ,
          };
  
          gamarekExemptionReqest.push(data);
        });
  
        taxItems.controls.forEach((control, index) => {
  
          var data={
            "id": this.idsZero==false ? control.get('id')?.value : 0 ,
            "ssCode": control.get('unitId')?.value,
            "quantity": control.get('quantity')?.value,
            "statisticalUnit": control.get('staticUnit')?.value,
            "exemptAssets": control.get('exemptAssets')?.value,
            "additionalCode":control.get('additionalCode')?.value ,
            "searchKeyword": control.get('unitName')?.value,
            "totalPrice": control.get('totalPrice')?.value
          };
  
          taxExemptionReqest.push(data);
        });
  
        var body={
          "model":{
            "carponcopyid": this.carbonCopyId,
            "taxNumber": this.form.get('taxNumber')?.value,
            "oldCarbonId": this.form.get('licenseId')?.value,
            "userId":this.employeeId,
            "jamarekItems": gamarekExemptionReqest,
            "taxItems":taxExemptionReqest,
            "userType":"2",
          }
        }
  
        var request=this.apiService.post('Moin/SubmitExemptionForm',body,`${environment.govnet}`,undefined,this.token);;
  
          request.subscribe(response=>{
            if(response){
              if(response.data.value==true){
              
                this.alertService.ShowAlert('success',' تم الحفظ بنجاح');
              }else{
                this.showSaveBtn=true;
              }
            }
          });
      }

    }else{
      console.log(this.form);
    }
  }

  
  
  fillStaticUnit(){
    var request= this.apiService.get('Moin/GetStatisticalUnits' , `${environment.govnet}`,undefined,this.token);;

    request.subscribe(response=>{
      var list=response.data.list;
      this.statisticalUnits=list;
    });

  }

  async getUnits(event:Event, index: number){
    
    const inputElement = event.target as HTMLInputElement; // Type assertion
    const text = inputElement.value;


    await this.searchEnquiry(text, index,true);

  }




  private searchEnquiry(text: string, index: number,refresh:boolean=false) {

    if(refresh){
      this.isLoading=true;
    }

    var request = this.apiService.get('Moin/GeneralEnquiry?description=' + text, `${environment.govnet}`,undefined,this.token);;

    request.subscribe(response => {

      this.isLoading=false;

      this.units[index] = response.data.list as any[];
    });
  }


  onUnitIdChange(event: any, index: number) {
    const selectedUnitId = event.target.value;


  
    const selectedUnit = this.units[index].find(unit => unit.key === selectedUnitId);

    if (selectedUnit) {
      const itemsArray = this.form.get('formItems') as FormArray;
      const itemGroup = itemsArray.at(index) as FormGroup;

      itemGroup.get('hsCode')?.setValue(selectedUnit.key);


    }
  }

  onTaxUnitIdChange(event: any, index: number) {
    const selectedUnitId = event.target.value;
  
    const selectedUnit = this.taxUnits[index].find(unit => unit.key === selectedUnitId);

    if (selectedUnit) {
      const itemsArray = this.form.get('taxItems') as FormArray;
      const itemGroup = itemsArray.at(index) as FormGroup;

      itemGroup.get('hsCode')?.setValue(selectedUnit.key);


    }
  }

  
}
